import service from './../../../services/warehouse/warehouseItem';

export default {
    namespaced: true,
    state: {
        data: [],
        params: {},
        options: { itemsPerPage: 15, page: 1 },
        loading : false,
        length: 0
    },
    getters: {
        params: state => state.params,
        options: state => state.options,
        data: state => state.data,
        loading: state => state.loading,
        length: state => state.length
    },
    mutations: {
        setOptions: (state, payload) => state.options = payload,
        setParams: (state, payload) => state.params = payload,
        setData: (state, payload) => state.data = payload,
        clearData: state => state.data = [],
        setLoading: (state, payload) => state.loading = payload,
        setLength: (state, payload) => state.length = payload
    },
    actions: {
        updateOptions(context, payload) {
            context.commit("setOptions", payload);
            context.dispatch("search");
        },
        updateParams(context, payload) {
            context.commit("setParams", payload);
            context.dispatch("search");
        },
        search(context){
            return new Promise((resolve, reject) => {
                context.commit("setLoading", true);
                context.commit("clearData");
                service.list({...context.state.options, ...context.state.params}).then(response => {
                    context.commit("setData", response.data.data)
                    context.commit("setLength", response.data.count)
                    resolve(response)
                }).catch(error => {
                    reject(error)
                }).finally(() => context.commit("setLoading", false))
            })
        }
    }
}